import dayjs from '@plugins/local-dayjs'
import { FieldTypeMap, RelationTypeMap, RuleLogicMap } from '../../../../common/common'
import { isNumericCompareLogic, isEmptyCheckLogic } from './applyFieldRuleOptions'

const CONTENT_LOGIC_LABELS = {
  [RuleLogicMap.include]: '包含',
  [RuleLogicMap.exclude]: '不包含',
  [RuleLogicMap.equal]: '等于',
  [RuleLogicMap.greaterThan]: '大于',
  [RuleLogicMap.lessThan]: '小于',
  [RuleLogicMap.isEmpty]: '为空',
  [RuleLogicMap.isNotEmpty]: '不为空'
}

const RELATION_LABELS = {
  [RelationTypeMap.and]: '，且',
  [RelationTypeMap.or]: '，或',
  [RelationTypeMap.not]: '，非'
}

const getContentLogicLabel = (contentLogicType) => {
  return CONTENT_LOGIC_LABELS[contentLogicType] || ''
}

const getRelationLabel = (ruleLogicType) => {
  return RELATION_LABELS[ruleLogicType] || '，且'
}

const formatConditionValue = (formData) => {
  const { selectContentName, selectContentItems, fieldType } = formData

  if (selectContentItems?.length) {
    const labels = selectContentItems.map(item => {
      return item?.dictLabel || item?.label || ''
    }).filter(Boolean)

    if (labels.length) {
      return labels.join('、')
    }
  }

  if (selectContentName == null || selectContentName === '') {
    return ''
  }

  if (fieldType === FieldTypeMap.select) {
    if (Array.isArray(selectContentName)) {
      return selectContentName.join('/')
    }
    return String(selectContentName)
  }

  if (fieldType === FieldTypeMap.dateRangePicker && Array.isArray(selectContentName)) {
    return selectContentName.map(date => {
      return date ? dayjs(date).format('YYYY-MM-DD') : '无期限'
    }).join('~')
  }

  if (fieldType === FieldTypeMap.cascader && Array.isArray(selectContentName)) {
    return selectContentName.join('/')
  }

  if (isNumericCompareLogic(formData.contentLogicType)) {
    return String(selectContentName)
  }

  return String(selectContentName).replace(/\|/g, '、')
}

const formatCondition = (row, rowIndex) => {
  const formData = row?.formData
  if (!formData?.fieldCode) {
    return ''
  }

  const fieldName = formData.fieldName || formData.ruleName
  const logicLabel = getContentLogicLabel(formData.contentLogicType)
  const valueText = formatConditionValue(formData)

  if (!fieldName || !logicLabel) {
    return ''
  }

  if (valueText === '' && !isNumericCompareLogic(formData.contentLogicType) && !isEmptyCheckLogic(formData.contentLogicType)) {
    return ''
  }

  const relationPrefix = rowIndex > 0 ? getRelationLabel(formData.ruleLogicType) : ''
  if (isEmptyCheckLogic(formData.contentLogicType)) {
    return `${relationPrefix}"${fieldName}""${logicLabel}"`
  }
  return `${relationPrefix}"${fieldName}""${logicLabel}""${valueText}"`
}

const formatSubRuleGroup = (group) => {
  return (group.children || [])
    .map((row, index) => formatCondition(row, index))
    .filter(Boolean)
    .join('')
}

export const generateApplyFieldRuleDescription = (ruleItem) => {
  const mainFieldName = ruleItem?.formData?.fieldName
  if (!mainFieldName) {
    return ''
  }

  const groupTexts = (ruleItem.children || [])
    .map(group => formatSubRuleGroup(group))
    .filter(Boolean)

  if (!groupTexts.length) {
    return `"${mainFieldName}"字段暂未配置完整子规则。`
  }

  const conditionsText = groupTexts.length === 1
    ? groupTexts[0]
    : groupTexts.map((text, index) => {
      return index === 0 ? text : `或${text}`
    }).join('')

  return `"${mainFieldName}"字段需${conditionsText}时才需要填写。`
}

export default generateApplyFieldRuleDescription
